

import { YearChoices, LossTypeChoices, LossSeasonChoices, msoCalcTypeChoices, honeycombMapCoordinates } from './constants'
import { clickToSort, renderOneStateBarChart } from './loss_table_components'
import lossJson from './LMS2022_States_Loss.json' assert {type: 'json'}

// Global variables:
var lossClass = "fas fa-caret-square-up"
// setting currentSort here controlls the default sort on page load.
var currentSort = "stateName"  //  Set default to State.
var direction = "ascending"
var parmsAfterSort = {}


function render(config, selectedYear, selectedLossCalc, selectedSeason, selectedOpType) {
  renderLossMap(config, selectedYear, selectedLossCalc, selectedSeason, selectedOpType)
}

$(function () {
  const config = JSON.parse(document.getElementById('config').textContent)

  // YearChoices is an array of arrays.
  // .length -1 will return the last ellement in the first array.
  // [0] will get the first element out of .length -1.
  const initial_year = YearChoices[YearChoices.length -1][0];

  const initial_lossCalc = 'total_loss'
  const initial_season = 'Winter'
  const initial_opType = 'MSO in'


  render(config, initial_year, initial_lossCalc, initial_season, initial_opType)


  // onChange year picker logic.
  let $yearPicker = $('<select class="form-select" ></select>')
  $('.year-picker').append($yearPicker)
  Object.entries(YearChoices).forEach(entry => {
    const [key, value] = entry;
    $yearPicker.append(`<option value="${value[0]}">${value[1]}</option>`)
  });

  $yearPicker.val(initial_year)
  $yearPicker.on('change', () => {
    let selectedYear = parseInt($yearPicker.val())
    let selectedLossCalc = $lossCalcPicker.val()
    let selectedSeason = $seasonPicker.val()
    let selectedOpType = $operationTypePicker.val()
    render(config, selectedYear, selectedLossCalc, selectedSeason, selectedOpType)
  })


  // onChange Loss Claculation picker logic.
  let $lossCalcPicker = $('<select class="form-select" ></select>')
  $('.lossCalc-picker').append($lossCalcPicker)
  Object.entries(LossTypeChoices).forEach(entry => {
    const [row, choice] = entry;
    $lossCalcPicker.append(`<option value="${choice.value}">${choice.text}</option>`)
  });

  $lossCalcPicker.val(initial_lossCalc)
  $lossCalcPicker.on('change', () => {
    let selectedYear = parseInt($yearPicker.val())
    let selectedLossCalc = $lossCalcPicker.val()
    let selectedSeason = $seasonPicker.val()
    let selectedOpType = $operationTypePicker.val()
    render(config, selectedYear, selectedLossCalc, selectedSeason, selectedOpType)
  })


  // onChange Season picker logic.
  let $seasonPicker = $('<select class="form-select" ></select>')
  $('.season-picker').append($seasonPicker)
  Object.entries(LossSeasonChoices).forEach(entry => {
    const [row, choice] = entry;
    $seasonPicker.append(`<option value="${choice.value}">${choice.text}</option>`)
  });

  $seasonPicker.val(initial_season)
  $seasonPicker.on('change', () => {
    let selectedYear = parseInt($yearPicker.val())
    let selectedLossCalc = $lossCalcPicker.val()
    let selectedSeason = $seasonPicker.val()
    let selectedOpType = $operationTypePicker.val()
    render(config, selectedYear, selectedLossCalc, selectedSeason, selectedOpType)
  })


  // onChange Operation Type picker logic.
  let $operationTypePicker = $('<select class="form-select" ></select>')
  $('.operationType-picker').append($operationTypePicker)
  Object.entries(msoCalcTypeChoices).forEach(entry => {
    const [row, choice] = entry;
    $operationTypePicker.append(`<option value="${choice.value}">${choice.text}</option>`)
  });

  $operationTypePicker.val(initial_opType)
  $operationTypePicker.on('change', () => {
    let selectedYear = parseInt($yearPicker.val())
    let selectedLossCalc = $lossCalcPicker.val()
    let selectedSeason = $seasonPicker.val()
    let selectedOpType = $operationTypePicker.val()
    render(config, selectedYear, selectedLossCalc, selectedSeason, selectedOpType)
  })



})



/**
 * Filter By Selection - takes 3 parameters to be tested/included then
   inside of filterBySelection is another function that takes the array element
   that is passed by lossJson.filter.  In this case arrayElement refers to
   lossJson and SurveyYear is one of the fields in lossJson
 * @param  {String} testYear  - Only include in resulting array if equal to SurveyYear.
 * @param  {String} testSeason  - Only include in resulting array if equal to Season (Winter, Summer, Annual).
 * @param  {String} testOpType  - Only include in resulting array if equal to Method (MSO-in, MSO-out, MSO-only).
 * @return {Array}  lossStateDataPerYear - Null or a positive number rounded to 2 decimal places.
 */
function filterBySelection(testYear, testSeason, testOpType) {
  return function(arrayElement){
    if (arrayElement.SurveyYear == testYear && arrayElement.Season == testSeason
      && arrayElement.Method == testOpType) {
        return true
    }
  }
}


/**
  loss State Data Per Year - The filter() method used here creates a new
  array filled with elements that pass a test provided by a function.  Only
  if filterBySelection returns TRUE will the original array element be put
  in the new array.  lossJson holds all of the LM Survey data
  for all years, all Seasons and all Operation Types.
*/
const lossStateDataPerYear = (config, year, testSeason, testOpType) =>
  lossJson.filter(filterBySelection(year, testSeason, testOpType))



/**
 * Percent or Null  - Will return null if paramater passed is < 0. Otherwise it
   converts the string passed to a foalt numeric and rounds to 2 decimal places.
 * @param  {String} percentString  - The number to convert, passed in string form.
 * @return {Number}                - Null or a positive number rounded to 2 decimal places.
 */
function percentOrNull(percentString) {
  return percentString > 0 ? Number(parseFloat(percentString).toFixed(2)) : null
};



/**
 * Get Loss Calculation  - Loss calculation can be either Total Loss or Average Loss.
     As of July 2022 we are refering to TL as "weighted average" and AL as
     "unweighted average".
 * @param  {Array} dataPassed - The array containing Total Loss in dataPassed[TL] and Average Loss in dataPassed[AL].
 * @return {Number}           - Null or a number representing Total Loss or Average loss rounded
 *                              to 2 decimal positions.
 */
function getLossCalc(dataPassed, selectedLossCalc){
  if (selectedLossCalc == "total_loss"){
    // Loss Calculation Total "weighted average" uses TL.
    return percentOrNull(dataPassed["TL"]);
  } else{
    // Loss Calculation Average "unweighted average" uses AL.
    return percentOrNull(dataPassed["AL"]);
  }
}

/**
 *
 * @param {Array} dataPassed    - Array containing LMS data including TL & AL confidence intervals.
 * @param {String} selectedLossCalc  - The Loss Calc selected, Total "weighted average" or
 *                                     Average "unweighted average"
 * @returns {Number}                 - Null or a number rounded to 2 decimal positions that represents
 *                                     the 25% confidence interval.
 */
function getCI25(dataPassed, selectedLossCalc){
  if (selectedLossCalc == "total_loss"){
    // Loss Calculation Total "weighted average" uses TL.
    return percentOrNull(dataPassed["TL.b.025perc"]);
  } else{
    // Loss Calculation Average "unweighted average" uses AL.
    return percentOrNull(dataPassed["AL.b.025perc"]);
  }
}

/**
 *
 * @param {Array} dataPassed    - Array containing LMS data including TL & AL confidence intervals.
 * @param {String} selectedLossCalc  - The Loss Calc selected, Total "weighted average" or
 *                                     Average "unweighted average"
 * @returns {Number}                 - Null or a number rounded to 2 decimal positions that represents
 *                                     the 95% confidence interval.
 */
function getCI97(dataPassed, selectedLossCalc){
  if (selectedLossCalc == "total_loss"){
    // Loss Calculation Total "weighted average" uses TL.
    return percentOrNull(dataPassed["TL.b.975perc"]);
  } else{
    // Loss Calculation Average "unweighted average" uses AL.
    return percentOrNull(dataPassed["AL.b.975perc"]);
  }
}






function renderLossMap(config, selectedYear, selectedLossCalc, selectedSeason, selectedOpType) {

  // lossStateDataPerYear will use .filter to get data from config for only
  // the selectedYear, selectedSeason and selectedOpType.
  const data2 = lossStateDataPerYear(config, selectedYear, selectedSeason, selectedOpType)



  // Out of all fields, .map returns only the ones specified in return{} block.
  const data = honeycombMapCoordinates.map(s => {
    try{
      const data3 = data2.find(element => element['state'] == s.name);
        var value = getLossCalc(data3, selectedLossCalc)
        var Beekeepers = data3.N
        var CI25 = getCI25(data3, selectedLossCalc)
        var CI97 = getCI97(data3, selectedLossCalc)
        var Colonies = data3.TotalColAtRisk
        var testingYear = data3.SurveyYear
        var exclusiveBeekeepers = percentOrNull(data3.PtBkExclusiveToState)
        var exclusiveColonies = percentOrNull(data3.PColExclusiveToState)
    }
    catch(err) {
      // For any state that is in honeycombMapCoordinates but not in data2, we need this try/catch logic.
      var value = null
      var Beekeepers = 0
      var CI25 = 0
      var CI97 = 0
      var Colonies = 0
      var testingYear = 0
      var exclusiveBeekeepers = 0
      var exclusiveColonies = 0
    }

    return {
        x: s.x,
        y: s.y,
        stateName: s.name,
        stateAbr: s['hc-a2'],
        value: value,
        Beekeepers: Beekeepers,
        CI25: CI25,
        CI97: CI97,
        Colonies: Colonies,
        testingYear: testingYear,
        exclusiveBeekeepers: exclusiveBeekeepers,
        exclusiveColonies: exclusiveColonies
    }
  })



  // selectedOpType will = "MSO in" when heading shoud show "All".
  // showOpType will be an array of one element containing: "{text: 'All', value: 'MSO in'}"
  let showOpType = msoCalcTypeChoices.filter(function (element) {
    return element.value == selectedOpType;
  });

  let showLossType = LossTypeChoices.filter(function (element) {
    return element.value == selectedLossCalc;
  });

  let showYear = YearChoices.filter(function (element) {
    if (element[0] == selectedYear){
      return element
    }
  });





  // This call to clickToSort happens on page load and when the selection criteria is reset.
  // clickToSort will toggle direction (ascending to descending or descending to ascending).
  // Reverse direction here so sort remains in the same direction for criteria changes.
  if(direction == "ascending"){
    direction = "descending"
  }else{
    direction = "ascending"
  }
  parmsAfterSort = clickToSort(currentSort, lossClass, direction, data)
  lossClass = parmsAfterSort.lossClass
  direction = parmsAfterSort.direction
  currentSort = parmsAfterSort.sortByField
  renderLossTable(config, selectedYear, showLossType, selectedSeason, showOpType)




  // Logic for Table that displays data for each state below the map. **************************************************************
  function renderLossTable(config, selectedYear, showLossType, selectedSeason, showOpType) {

    document.getElementById("State").onclick = function() {parmsAfterSort = clickToSort("stateName", lossClass, direction, data)
    lossClass = parmsAfterSort.lossClass
    direction = parmsAfterSort.direction
    currentSort = parmsAfterSort.sortByField
    renderLossTable(config, selectedYear, showLossType, selectedSeason, showOpType)
    // GA4 event code.
    gtag ('event', 'Loss_Map_Sort_Change', {
      'screen_name': 'loss_map2.html',
      'sort_by_column' : 'stateName'
    })
    }
    document.getElementById("lossTitle").onclick = function() {parmsAfterSort = clickToSort("value", lossClass, direction, data)
      lossClass = parmsAfterSort.lossClass
      direction = parmsAfterSort.direction
      currentSort = parmsAfterSort.sortByField
      renderLossTable(config, selectedYear, showLossType, selectedSeason, showOpType)
      // GA4 event code.
      gtag ('event', 'Loss_Map_Sort_Change', {
        'screen_name': 'loss_map2.html',
        'sort_by_column' : 'lossPercent'
      })
    }
    document.getElementById("Beekeepers").onclick = function() {parmsAfterSort = clickToSort("Beekeepers", lossClass, direction, data)
      lossClass = parmsAfterSort.lossClass
      direction = parmsAfterSort.direction
      currentSort = parmsAfterSort.sortByField
      renderLossTable(config, selectedYear, showLossType, selectedSeason, showOpType)
      // GA4 event code.
      gtag ('event', 'Loss_Map_Sort_Change', {
        'screen_name': 'loss_map2.html',
        'sort_by_column' : 'Beekeepers'
      })
    }
    document.getElementById("BKExcState").onclick = function() {parmsAfterSort = clickToSort("exclusiveBeekeepers", lossClass, direction, data)
      lossClass = parmsAfterSort.lossClass
      direction = parmsAfterSort.direction
      currentSort = parmsAfterSort.sortByField
      renderLossTable(config, selectedYear, showLossType, selectedSeason, showOpType)
      // GA4 event code.
      gtag ('event', 'Loss_Map_Sort_Change', {
        'screen_name': 'loss_map2.html',
        'sort_by_column' : 'exclusiveBeekeepers'
      })
    }
    document.getElementById("Colonies").onclick = function() {parmsAfterSort = clickToSort("Colonies", lossClass, direction, data)
      lossClass = parmsAfterSort.lossClass
      direction = parmsAfterSort.direction
      currentSort = parmsAfterSort.sortByField
      renderLossTable(config, selectedYear, showLossType, selectedSeason, showOpType)
      // GA4 event code.
      gtag ('event', 'Loss_Map_Sort_Change', {
        'screen_name': 'loss_map2.html',
        'sort_by_column' : 'Colonies'
      })
    }
    document.getElementById("ColExcState").onclick = function() {parmsAfterSort = clickToSort("exclusiveColonies", lossClass, direction, data)
      lossClass = parmsAfterSort.lossClass
      direction = parmsAfterSort.direction
      currentSort = parmsAfterSort.sortByField
      renderLossTable(config, selectedYear, showLossType, selectedSeason, showOpType)
      // GA4 event code.
      gtag ('event', 'Loss_Map_Sort_Change', {
        'screen_name': 'loss_map2.html',
        'sort_by_column' : 'exclusiveColonies'
      })
    }


    // clear out old HTML <tr> & <td> tags.
    document.getElementById("lossTableBody").innerHTML = ""

    let lossTableBody = document.getElementById("lossTableBody")
    document.getElementById("lossTitle").innerHTML = ' <i id="lossIcon" class="' + lossClass + '"></i> ' + " " + showLossType[0].text + " " + selectedSeason + " " + showOpType[0].text + " Loss"


    // loop over all elements in data and build a <tr> for each state and <td> for each of column data to display.
    data.forEach(function (stateRow, index) {
      var lossGraphID = "LG" + index
      var newRow = document.createElement('tr')
      newRow.setAttribute("scope", "row")

      var newTD = document.createElement('td')
      newTD.setAttribute("scope", "col")
      newTD.innerHTML = stateRow.stateName
      newRow.appendChild(newTD)

      newTD = document.createElement('td')
      newTD.setAttribute("scope", "col")
      newTD.setAttribute("id", lossGraphID)
      newTD.setAttribute("width", "30%")
      newRow.appendChild(newTD)

      newTD = document.createElement('td')
      newTD.setAttribute("scope", "col")
      newTD.innerHTML = stateRow.Beekeepers
      newRow.appendChild(newTD)

      newTD = document.createElement('td')
      newTD.setAttribute("scope", "col")
      if(stateRow.exclusiveBeekeepers != null){
        newTD.innerHTML = stateRow.exclusiveBeekeepers + "%"
      }else{
        newTD.innerHTML = "N/A"
      }
      newRow.appendChild(newTD)

      newTD = document.createElement('td')
      newTD.setAttribute("scope", "col")
      newTD.innerHTML = stateRow.Colonies
      newRow.appendChild(newTD)

      newTD = document.createElement('td')
      newTD.setAttribute("scope", "col")
      if(stateRow.exclusiveColonies != null){
        newTD.innerHTML = stateRow.exclusiveColonies + "%"
      }else{
        newTD.innerHTML = "N/A"
      }
      newRow.appendChild(newTD)


      lossTableBody.appendChild(newRow)
      renderOneStateBarChart(stateRow.stateName, [stateRow.value], [[stateRow.CI25, stateRow.CI97]], lossGraphID)

    })


  }



  // Highcharts code for Survey Loss Map.  *******************************
  Highcharts.mapChart('lossNationalMap', {
    title: {
      text: `${showYear[0][1]} ${showLossType[0].text} ${selectedSeason} ${showOpType[0].text} Colony Loss`
    },
    subtitle: {
      text: ''
    },
    chart: {
      type: 'tilemap',
      inverted: true,
      height: '70%',  // 70% holds shape better than 60%
      // can not specify width!  width: '50%',
      marginTop: 100,
    },
    responsive: {
      rules: [
        {
          chartOptions: {
            chart: {
              // height: 500,
              // height: '55%',
            },
          },
          condition: {
            //maxWidth: 680
            //maxWidth: '15%',
          }
        }
      ]
    },
    legend: {
      layout: 'horizontal',
      borderWidth: 0,
      backgroundColor: '#fef9ec',
      floating: true,
      verticalAlign: 'top',
      y: 50
    },
    mapNavigation: {
      buttonOptions: {
        alignTo: 'spacingBox'
      },
      enabled: true,
      enableMouseWheelZoom: false
    },

    xAxis: {
      visible: false
    },

    yAxis: {
        visible: false
    },

    colorAxis: {
      min: 0,
      // comment out "max: 100" if you want Highcharts to change the
      // scale based on max value from the data.
      max: 100,

      // Colors from published report.
      stops: [
        [0.0, '#018571'],
         // Midpoint
        [0.30, '#f7f7f7'],
        // Max
        [0.95, '#ee7e00']
      ]

      // My Green-Blue_purple
      //stops: [
        // Green
        //[0.0005, '#f1fbe9'],
         // Blue
        //[0.15, '#9fd2f9'],
        //[0.40, '#56b0f5'],
        // purple
        //[0.77, '#5a0c41'],
        //[0.90, '#430931'],
        //[0.95, '#2d0621'],
        //[1, '#160310']
      //]


      // I like this one too:
      //stops: [
        //[0, '#fff2cc'],
        //[0.450, '#ffcb33'],
        //[1, '#332600']
      //]

    },

    plotOptions: {
      series: {
        nullColor: {
          pattern: {
            path: { d: 'M 0 28 L 28 0 M -4 4 L 4 -4 M 25 31 L 31 25',
                    strokeWidth: 9
            },
            color: '#b3b3b3',
            backgroundColor: '#cccccc',
            width: 28,
            height: 28,
            patternTransform: 'scale(1.5) rotate(0)'
          }
        },

        //colsize: 1.0625,  This did not help hexagones hold shape.
        //rowsize: 1,
        //pointPadding: 2
      }
    },

    series: [{
      data: data,
      // The joinBy option can be an array of two values, where the first
      // points to a key in the mapData, and the second points to a key in the data.
      // joinBy: ['name', 'stateName'],
      // name is in Highcharts (full name of the state)
      // stateName is in data.
      joinBy: ['name', 'stateName'],
      dataLabels: {
        allowOverlap: true,
        enabled: true,
        color: '#000000',
        format: '{point.stateAbr}',
        style: {
          fontWeight: 'bold'
        }

      },
      // name: data.stateName + data.TotalLoss,
      tooltip: {
        headerFormat: null,  // this line will suppress the name "Serries 1"
        nullFormat: '{point.stateName}: data is not available.',
        pointFormat: '<span>{point.stateName}: {point.value}%</span> <br> 95% Confidence Interval: {point.CI25} - {point.CI97} <br> Beekeepers: {point.Beekeepers} <br> Colonies: {point.Colonies}'
      },
      allowPointSelect: false,
      point: {

      }
    }]
  })

}

